var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3253 14.4001 9.69739 14.4001 8.00001C14.4001 6.30262 13.7258 4.67476 12.5256 3.47452C11.3253 2.27429 9.69748 1.60001 8.0001 1.60001C6.30271 1.60001 4.67485 2.27429 3.47461 3.47452C2.27438 4.67476 1.6001 6.30262 1.6001 8.00001C1.6001 9.69739 2.27438 11.3253 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM7.6441 5.73441C7.52362 5.65402 7.38357 5.60786 7.23891 5.60083C7.09425 5.5938 6.95039 5.62618 6.82269 5.69451C6.69498 5.76283 6.58822 5.86455 6.5138 5.9888C6.43937 6.11305 6.40008 6.25517 6.4001 6.40001V9.60001C6.40008 9.74484 6.43937 9.88696 6.5138 10.0112C6.58822 10.1355 6.69498 10.2372 6.82269 10.3055C6.95039 10.3738 7.09425 10.4062 7.23891 10.3992C7.38357 10.3922 7.52362 10.346 7.6441 10.2656L10.0441 8.66561C10.1537 8.59255 10.2435 8.49357 10.3056 8.37746C10.3678 8.26135 10.4003 8.1317 10.4003 8.00001C10.4003 7.86832 10.3678 7.73866 10.3056 7.62255C10.2435 7.50644 10.1537 7.40746 10.0441 7.33441L7.6441 5.73441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.5181634a79a3ddafc239e162c5fa2056.svg";
export { ForwardRef as ReactComponent };